@if (mode === 'READ' && message.content.cards.length === 0) {
  <div class="empty-card" i18n [attr.data-testid]="'empty-card-message'">
    這則卡片訊息中沒有任何卡片
  </div>
}

<div
  class="cards"
  [ngClass]="{ edit: mode === 'EDIT' }"
  cdkDropList
  cdkDropListOrientation="horizontal"
  cdkDropListLockAxis="x"
  [cdkDropListDisabled]="mode === 'READ'"
  (cdkDropListDropped)="drop($event)"
  [matTooltip]="message.content.alt"
  [attr.data-testid]="'cards-container'"
>
  @for (card of message.content.cards; track card; let index = $index) {
    <div
      cdkDrag
      class="card"
      [class.error]="hasError"
      [attr.data-testid]="'card-item-' + index"
    >
      <ms-card
        [card]="$any(card)"
        [package]="package"
        [message]="message"
        [matContextMenu]="contextMenu"
        [matContextMenuData]="{ card: card }"
        [matContextMenuDisable]="mode === 'READ'"
        (contextmenu)="selectedCard = $any(card)"
      >
      </ms-card>
    </div>
  }
</div>
@if (hasError) {
  <div
    class="flex items-center py-2"
    [ngClass]="{ 'justify-end': mode === 'READ' }"
  >
    <mat-icon class="text-red-500 mr-2 !h-[24px]">error</mat-icon>
    <span i18n>必填欄位資料有誤</span>
  </div>
}

<mat-menu #contextMenu="matMenu" class="tiny-menu">
  <ng-template matMenuContent let-card="card">
    @if (card.layout === 'share-add-friend') {
      <button mat-menu-item (click)="editCard()" i18n>
        <mat-icon>settings</mat-icon>編輯卡片
      </button>

      <button
        mat-menu-item
        (click)="swapMessageUpward()"
        [disabled]="isFirstMessage"
        i18n
      >
        <mat-icon>arrow_upward</mat-icon>上移
      </button>

      <button
        mat-menu-item
        (click)="swapMessageDownward()"
        [disabled]="isLastMessage"
        i18n
      >
        <mat-icon>arrow_downward</mat-icon>下移
      </button>
    } @else {
      <button
        mat-menu-item
        (click)="editCard()"
        i18n
        [attr.data-testid]="'edit-card-button'"
      >
        <mat-icon>settings</mat-icon>編輯卡片
      </button>

      <button
        mat-menu-item
        (mouseenter)="insertFrontCard()"
        [matMenuTriggerFor]="cards"
        i18n
        [attr.data-testid]="'insert-front-card-button'"
      >
        <mat-icon>add</mat-icon>新增前方卡片
      </button>
      <button
        mat-menu-item
        (mouseenter)="insertBehindCard()"
        [matMenuTriggerFor]="cards"
        i18n
        [attr.data-testid]="'insert-behind-card-button'"
      >
        <mat-icon>add</mat-icon>新增後方卡片
      </button>
      <button
        mat-menu-item
        (click)="deleteCard()"
        i18n
        [attr.data-testid]="'delete-card-button'"
      >
        <mat-icon>delete</mat-icon>刪除這張卡片
      </button>
      <div>
        <button
          mat-button
          (click)="swapCardLeft()"
          [disabled]="isFirstCard"
          i18n
          [attr.data-testid]="'move-left-button'"
        >
          <mat-icon>arrow_back</mat-icon>左移
        </button>
        <button
          mat-button
          (click)="swapCardRight()"
          [disabled]="isLastCard"
          i18n
          [attr.data-testid]="'move-right-button'"
        >
          右移<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <mat-divider></mat-divider>

      <button
        mat-menu-item
        (click)="editAlt(elementRef)"
        element-ref
        #elementRef="elementRef"
        i18n
        [attr.data-testid]="'edit-alt-text-button'"
      >
        <mat-icon>title</mat-icon>編輯替代文字
      </button>

      <button
        mat-menu-item
        (click)="deleteCards()"
        i18n
        [attr.data-testid]="'delete-all-cards-button'"
      >
        <mat-icon>delete</mat-icon>刪除整組卡片
      </button>

      <button
        mat-menu-item
        (click)="swapMessageUpward()"
        [disabled]="isFirstMessage"
        i18n
        [attr.data-testid]="'move-message-up-button'"
      >
        <mat-icon>arrow_upward</mat-icon>上移
      </button>
      <button
        mat-menu-item
        (click)="swapMessageDownward()"
        [disabled]="isLastMessage"
        i18n
        [attr.data-testid]="'move-message-down-button'"
      >
        <mat-icon>arrow_downward</mat-icon>下移
      </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #cards="matMenu" class="tiny-menu">
  <button
    mat-menu-item
    (click)="openCreator()"
    i18n
    [attr.data-testid]="'create-new-card-button'"
  >
    建立新卡片
  </button>
  <button
    mat-menu-item
    (click)="openTemplatePicker()"
    i18n
    [attr.data-testid]="'open-template-picker-button'"
  >
    從圖像編輯器中挑選
  </button>
</mat-menu>
